const Languages = () => {
	return (
	  <section className="languages">
		<h2 className="title-font  blue-text h2-tag">Languages</h2>
		<section>
		  <section>
			<h3>English</h3>
			<p>Professional working proficiency</p>
			<h3>Turkish</h3>
			<p>Native proficiency</p>
			<h3>French</h3>
			<p>Elementary proficiency</p>
		  </section>
		</section>
	  </section>
	);
  };
  
  export default Languages;
  